import { Table } from "mta-rkvr-styles";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { post } from "../api/fetch";
import { InterestMessagesRequestBody } from "../api/HomePageRequestTypes";
import { InterestMessagesResponseBody } from "../api/HomePageResponseTypes";
import CurrentUserContext from "../CurrentUserContext";
import { ColumnHeader, InterestMessage } from "../types/homepage/InterestMessages";
import { PaginationRequest, Paginator } from "../types/util/TableFunctionalityTypes";
import { toLocaleDate } from "../util/conversionUtils";
import { PROCEEDINGS } from "../util/paths";

const InterestMessages: React.FC<{
  teateType: "RVTEADE" | "KOVTEADE";
}> = ({ teateType }) => {
  const { t } = useTranslation();
  const tBase = "homePageAuth.interestMessages.";

  const { id } = useContext(CurrentUserContext);

  const [messages, setMessages] = useState<InterestMessage[]>();

  const [latestRequest, setLatestRequest] = useState<{
    paginationRequest: PaginationRequest;
  }>({
    paginationRequest: {
      offset: 0,
      limit: 10,
    },
  });

  useEffect(() => {
    getMessages();
  }, []);

  const getMessages = (paginationRequest = latestRequest.paginationRequest) => {
    setLatestRequest({ paginationRequest });
    post<InterestMessagesRequestBody /*PaginationRequest*/, InterestMessagesResponseBody>({
      endpoint: "kvvMessages",
      requestBody: {
        kasutaja: id,
        alamliik: teateType,
        ...paginationRequest,
      },
    }).then(async ({ body }) => {
      setMessages(
        body.resultsList.map((message) => {
          return {
            ...message,
            tahtaeg: toLocaleDate(message.tahtaeg),
          };
        }),
      );
      setPaginator({
        elementOffset: body.offset,
        numberOfElements: body.resultCount,
        pageSize: body.limit,
        totalElements: body.totalCount,
      });
    });
  };

  const [paginator, setPaginator] = useState<Paginator>();
  const onPagination = (paginator: { pageSize: number; elementOffset: number }) => {
    getMessages({
      offset: paginator.elementOffset,
      limit: paginator.pageSize,
    });
  };

  return (
    <>
      {messages && (
        <Table
          id={t(tBase + teateType.toLocaleLowerCase())}
          title={t(tBase + teateType.toLocaleLowerCase())}
          headers={Object.keys(ColumnHeader).map((header) => {
            return t(tBase + header);
          })}
          headerWithMaxWidth={[t(tBase + "content")]}
          content={messages?.map((message) => {
            const { menetluseId, menetluseNumber, sisu, tahtaeg, valitseja } = message;
            return {
              menetluseNumber: <Link to={`${PROCEEDINGS}/${menetluseId}`}>{menetluseNumber}</Link>,
              valitseja,
              tahtaeg,
              sisu,
            };
          })}
          translate={t}
          paginator={paginator}
          onPagination={onPagination}
          subTables={{
            headers: ["Valitseja", "Sisu"],
            contents: messages.map((message) => {
              return [{ valitseja: message.valitseja, teateSisu: message.sisu }];
            }),
            togglers: ["sisu"],
          }}
        />
      )}
    </>
  );
};

export default InterestMessages;
